import {
  FormGroup,
  Icon,
  FormGroupProps,
  Position,
  Classes,
} from "@blueprintjs/core"
import { DateInput, DateInputProps } from "@blueprintjs/datetime"
import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import advancedFormat from "dayjs/plugin/advancedFormat"
import React from "react"
import classNames from "utils/classNames"
import {
  FormControllerProps,
  withFormController,
} from "../Molecules/FormController"
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)

interface CustomDateInputProps
  extends FormGroupProps,
    Omit<DateInputProps, "onChange" | "value">,
    FormControllerProps {
  value?: Date | string
  path: string
  format?: string
  [key: string]: any
}
const CustomDateInput = ({
  value,
  onChange,
  popoverProps,
  path,
  label,
  inline,
  error,
  labelInfo,
  helperText,
  intent,
  className,
  big,
  fill,
  format,
  required,
  ...OtherDateInputProps
}: CustomDateInputProps) => {
  function formatToObject(dateText: Date | string) {
    let dateValue
    if (dateText instanceof Date) {
      dateValue = dateText
    } else {
      if (dayjs(dateText).isValid() && dayjs(dateText).toISOString()) {
        dateValue = dayjs(dateText).toDate()
      } else {
        dateValue = dayjs(dateText, format).toDate()
      }
    }

    return dateValue
  }

  function handleDateChange(date: Date) {
    const formattedDate = dayjs(date).format("YYYY-MM-DD")

    onChange && onChange(path, formattedDate)
  }

  return (
    <FormGroup
      helperText={error && value ? error : helperText}
      intent={error && value ? "danger" : intent}
      labelInfo={
        required ? <span className={Classes.INTENT_DANGER}>*</span> : labelInfo
      }
      className={classNames(
        "vt-custom-dateinput",
        { "vt-input-big": big, "vt-input-stretch": fill },
        className
      )}
      label={label}
      inline={inline}
    >
      <DateInput
        popoverProps={popoverProps}
        {...OtherDateInputProps}
        formatDate={date => dayjs(date).format(format)}
        parseDate={str => new Date(str)}
        onChange={handleDateChange}
        value={value ? formatToObject(value) : undefined}
      />
    </FormGroup>
  )
}

CustomDateInput.defaultProps = {
  popoverProps: {
    position: Position.BOTTOM_LEFT,
    minimal: true,
  },
  format: "Do MMM YYYY",
  rightElement: (
    <Icon className="h-full flex justify-center items-center" icon="calendar" />
  ),
  placeholder: "DD/MM/YYYY",
  maxDate: dayjs(new Date()).add(50, "years").toDate(),
  minDate: dayjs(new Date()).subtract(100, "years").toDate(),
  big: true,
  fill: true,
}
export default withFormController(CustomDateInput)
